import React from 'react';
import PropTypes from 'prop-types';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import { Route, HashRouter, Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import WelcomeIcon from '@material-ui/icons/Home';
import WeatherIcon from '@material-ui/icons/Cloud';
import CameraIcon from '@material-ui/icons/Camera';
import DataEntryIcon from '@material-ui/icons/Edit';
import ColorTransformIcon from '@material-ui/icons/InvertColors';
import ExerciseIcon from '@material-ui/icons/DirectionsBike';

import Welcome from "./Welcome";
import Weather from "./Weather";
import Images from "./Images";
import DataEntry from "./DataEntry";
import ColorTransform from "./ColorTransform";
import Exercise from "./Exercise";

const styles = theme => ({
    menuItem: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& $primary, & $icon': {
                color: theme.palette.common.white,
            },
        },
    },
    primary: {
        fontFamily: '"Lato", Arial',
        fontWeight: '400',
    },
    icon: {},
});

function Menu(props) {
    const { classes } = props;

    return (
        <Paper>
            <HashRouter>
                <div className="layout-cont">
                    <div className="menu">
                        <MenuList>
                            <MenuItem className={classes.menuItem} component={Link} to="/">
                                <ListItemIcon className={classes.icon}>
                                    <WelcomeIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} inset primary="Welcome" />
                            </MenuItem>
                            <MenuItem className={classes.menuItem} component={Link} to="/ColorTransform">
                                <ListItemIcon className={classes.icon}>
                                    <ColorTransformIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} inset primary="Color Transform" />
                            </MenuItem>
                            <MenuItem className={classes.menuItem} component={Link} to="/DataEntry">
                                <ListItemIcon className={classes.icon}>
                                    <DataEntryIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} inset primary="Data Entry" />
                            </MenuItem>
                            <MenuItem className={classes.menuItem} component={Link} to="/Exercise">
                                <ListItemIcon className={classes.icon}>
                                    <ExerciseIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} inset primary="Exercise" />
                            </MenuItem>
                            <MenuItem className={classes.menuItem} component={Link} to="/Images">
                                <ListItemIcon className={classes.icon}>
                                    <CameraIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} inset primary="Photography" />
                            </MenuItem>
                            <MenuItem className={classes.menuItem} component={Link} to="/Weather">
                                <ListItemIcon className={classes.icon}>
                                    <WeatherIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} inset primary="Current Weather" />
                            </MenuItem>
                        </MenuList>
                    </div>
                    <div className="content">
                        <Route exact path="/" component={Welcome} />
                        <Route path="/Weather" component={Weather} />
                        <Route path="/Images" component={Images} />
                        <Route path="/DataEntry" component={DataEntry} />
                        <Route path="/Exercise" component={Exercise} />
                        <Route path="/ColorTransform" component={ColorTransform} />
                    </div>
                </div>
            </HashRouter>
        </Paper>
    );
}

Menu.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Menu);


// WEBPACK FOOTER //
// ./src/components/Menu.js